<template>
    <router-link :to="to" v-if-has-access="getRequiredAccesses(to)">
        <slot :data="{to, label}">
            <md-button :class="getLinkClass(to)">{{ label }}</md-button>
        </slot>
    </router-link>
</template>

<script>
    export default {
        name: "ConditionalRouterLink",
        props: {
            to: {
                type: [String, Object],
                default: undefined
            },
            label: {
                type: String,
                default: ''
            }
        },
        methods: {
            getRequiredAccesses(path) {
                return _.get(this.$router.resolve(path), 'route.meta.roles', []);
            },
            getLinkClass(route) {
                if(this.to.path)
                    return `md-dense md-primary custom-button ${this.isActiveRoute(this.to.path) ? 'active-navigation-button' : ''}`
                else
                    return `md-dense md-primary custom-button ${this.isActiveRoute(route) ? 'active-navigation-button' : ''}`
            },
            isActiveRoute(route) {
                if(this.to.path)
                    return this.$route.path.toLowerCase().startsWith(this.to.path.toLowerCase())
                else
                    return this.$route.path.toLowerCase().startsWith(route.toLowerCase());
            }
        }
    }
</script>

<style scoped>

</style>
